import React from 'react';
import { Link } from 'react-router-dom';
import PageBanner from '../components/PageBanner';

// Rendered for any URL no other route matches. The server side
// (api/render-page.php) already answers unknown paths with a 404 status,
// so this page is what both visitors and crawlers see on a bad link.
const HELPFUL_LINKS = [
  { to: '/',             label: 'Home',           desc: 'Back to the Mind Spa India homepage.' },
  { to: '/services',     label: 'Our Services',   desc: 'Psychotherapy, hypnotherapy, counselling and coaching.' },
  { to: '/consultation', label: 'Consultation',   desc: 'Meet our consultants and book a session.' },
  { to: '/courses',      label: 'Courses',        desc: 'Clinical hypnotherapy diplomas and training.' },
  { to: '/blogs',        label: 'Blog',           desc: 'Articles on mental health and self-help.' },
  { to: '/contact',      label: 'Contact Us',     desc: 'Reach the clinic in Lucknow.' },
];

function NotFoundPage() {
  return (
    <div className="not-found-page">
      <PageBanner title="Page Not Found" />
      <section className="section" style={{ background: 'var(--bg-white)' }}>
        <div className="container" style={{ maxWidth: 900, textAlign: 'center' }}>
          <p style={{ fontSize: '1.1rem', color: 'var(--text-body)', margin: '0 auto 2rem', maxWidth: 560 }}>
            The page you're looking for doesn't exist or may have moved.
            Here are a few places to continue exploring:
          </p>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
              gap: '1rem',
              textAlign: 'left',
              marginBottom: '2.5rem',
            }}
          >
            {HELPFUL_LINKS.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                style={{
                  display: 'block',
                  padding: '1.1rem 1.25rem',
                  border: '1px solid var(--border-light)',
                  borderRadius: 12,
                  background: 'var(--bg-section)',
                  textDecoration: 'none',
                }}
              >
                <strong style={{ display: 'block', color: 'var(--text-heading)', fontFamily: 'var(--font-heading)', fontSize: '1.05rem', marginBottom: 4 }}>
                  {l.label}
                </strong>
                <span style={{ color: 'var(--text-body)', fontSize: '0.9rem' }}>{l.desc}</span>
              </Link>
            ))}
          </div>
          <Link to="/" className="btn-primary">Take me home</Link>
        </div>
      </section>
    </div>
  );
}

export default NotFoundPage;
